import React, { useState } from "react";
import "./Receive_Product_Modal.css";
import { Modal, Table } from "react-bootstrap";
import ModalSave from "../../common/ModelSave";
import { postData } from "../../../utils/api";

function Receive_Product_Modal({ ...props }) {
  console.log(props, "props");

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const productReceived = async (id) => {
    const response = await postData(
      `/delivery-boy-manegement/delivery-boy-collect-undeliverd-product/receive-product/${id}`
    );
    if (response?.success) {
      await setShowModal({ code: response.code, message: response.message });

      setTimeout(() => {
        props.onHide(true);
      }, 1000);
    } else {
      await setShowModal({
        code: response?.code,
        message: response?.message,
      });
    }

    setTimeout(() => {
      setShowModal(0);
      props.getDataAll();
    }, 1000);
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Details_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Receive Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="data  withdrow-table-holder table-responsive">
            <Table striped bordered hover responsive center>
              <thead>
                <tr className="">
                  <th>Sr. No.</th>
                  <th> Product Name</th>
                  <th> Quantity</th>
                  <th> Recived From Delivery Boy</th>
                </tr>
              </thead>
              <tbody>
                {props?.orderData?.length > 0 ? (
                  props.orderData.map((d, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {d?.product_variant?.v_name
                            ? `${d?.product?.name} (${d?.product_variant?.v_name})`
                            : d?.product_multiple_variant?.varient_sub_name
                            ? `${d?.product?.name} (${d?.product_multiple_variant?.varient_sub_name})`
                            : d?.product?.name}
                        </td>

                        <td>{d.quantity}</td>
                        <td>
                          <button
                            className="subscription-btnnn"
                            onClick={() => productReceived(d?.id)}
                          >
                            Receive From Delivery Boy
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      Data not available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
}

export default Receive_Product_Modal;
